import * as React from 'react'
import { ActivityIndicator } from 'react-native'

import theme from '@theme/Theme'

interface Props {
  color?: string
}

const Loader = ({ color = theme.colors.primary }: Props) => <ActivityIndicator color={color} size={25} />

export default Loader
